<template>
  <nav
    class="relative z-0 inline-flex items-center space-x-4 rounded-md"
    aria-label="Pagination"
  >
    <button
      href="#"
      class="relative inline-flex items-center rounded-l-md p-2 text-sm font-medium text-background-fg/70 hover:text-background-fg"
      @click="onPrevious"
    >
      <span class="sr-only">Previous</span>
      <IconHeroiconsSolidChevronLeft
        class="size-5"
        aria-hidden="true"
      />
    </button>
    <div class="text-sm text-background-fg/70">
      {{ modelValue }} / {{ pageCount }}
    </div>
    <button
      class="relative inline-flex items-center rounded-r-md p-2 text-sm font-medium text-background-fg/70 hover:text-background-fg"
      @click="onNext"
    >
      <span class="sr-only">Next</span>
      <IconHeroiconsSolidChevronRight
        class="size-5"
        aria-hidden="true"
      />
    </button>
  </nav>
</template>
<script setup>
const props = defineProps({
  pageCount: {
    type: Number,
    default: 0,
  },
  modelValue: {
    type: Number,
    default: 1,
  },
})

const emit = defineEmits(["update:modelValue"])

const onNext = () => {
  emit(
    "update:modelValue",
    Math.min(props.modelValue + 1, props.pageCount)
  )
}
const onPrevious = () => {
  emit(
    "update:modelValue",
    Math.max(props.modelValue - 1, 1)
  )
}
</script>
